module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }